import {Component, Input, OnInit, Output, ViewChild, ViewChildren} from '@angular/core';
import { MatMenu } from '@angular/material';
import { EventEmitter } from '@angular/core';
import { DataItem } from '../model/data.item';
// import {Router} from '@angular/router';
// import {NavItem} from '../nav-item';

@Component({
    selector: 'lookup-menu-item',
    templateUrl: './lookup.menu.html',
    styleUrls: ['./input.scss']
  })
  export class LookupMenuItem implements OnInit {
    @Input() 
    items: DataItem[];
    
    @ViewChild('childMenu', {static: true, read: MatMenu}) 
    public childMenu;
  
    @Output('select')
    onSelect: EventEmitter<DataItem> = new EventEmitter<DataItem>()

    // constructor(public router: Router) {
    // }
  
    ngOnInit() {
    }

    select(item: DataItem) {
        this.onSelect.emit(item);
    }
  }